import React from 'react'

export default () => {
    return (
        <style>
            {`
                    .view-subscription-btn-edit
                    {
                        height:40px;
                    }
        
                    .view-subscription-btn{
                        height:40px;
                        width: 169px;
        
                    }
                    .applying-flex-products-btn{
                        display:flex;
                    }
                    .view-subscription-btn-products{
                        height: 40px;
                        width: 72px;
                        padding-top: 6px;
                    }
                    .border-bottom{
                        border-bottom: 1px solid silver;
                    }
            `}
        </style>
    );
}